module.exports = __webpack_public_path__ + "img/img15.474781ec.png";